var styles = {
  helpIcon: {
    display: "inline-block",
    position: "relative",
    left: "4px",
    top: "2px",
    cursor: "pointer"
  }
};
export default styles;